import React, { useState, useRef, useMemo } from 'react'
import { observer } from 'mobx-react'
import { wxConfigG } from 'controllers/third'
import Recorder from 'controllers/record'
import { menuMobx } from 'restaurant'
import { posServiceMobx, voiceServiceMobx } from '@mobxStore'
import { mpc } from '@dt/mmg-sdk'
import SOUNDGIF from '@img/sound.gif'
import './index.scss'
import { classNames } from '@dt/fe-utils'

interface IContentItem {
  content: string;
  content_id: string;
  content_type: string;
  score: number;
}

interface IProps {
  type: 'search' | 'serviceRing';
  className?: string;
  onReject?: any;
  onStart?: () => void;
  onResult?: () => void;
}

const VoiceServiceContent: React.FC<IProps> = ({ type = 'search', className, onReject, onStart, onResult }) => {
  const [isRecording, setIsRecording] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [isCallService, setIsCallService] = useState<boolean>(false)
  const [isErr, setIsErr] = useState<boolean>(false)
  const [localId, setLocalId] = useState<string>()
  const timer = useRef(null)
  const recorder = useRef(null)
  const voiceDuration = useRef(8)
  const voiceDurationInter = useRef(null)
  const [closeDuration, setCloseDuration] = useState(3)
  const closeDurationInter = useRef(null)
  const { isOpenSearchProduct, isOpenSearchActivity, isOpendServiceRing } = voiceServiceMobx
  const { sendServiceRing } = posServiceMobx

  // 关闭倒计时
  const countDownClose = () => {
    let duration = 3
    closeDurationInter.current = setInterval(() => {
      if (duration === 0) {
        clearInterval(closeDurationInter.current)
        closeDurationInter.current = null
        onResult?.()
        return
      }
      duration--
      setCloseDuration(duration)
    }, 1000)
  }

  // 开始倒计时
  const startCountDown = () => {
    voiceDuration.current = 8
    voiceDurationInter.current = setInterval(() => {
      if (voiceDuration.current === 0) {
        clearInterval(voiceDurationInter.current)
        stopRecord()
        return
      }
      voiceDuration.current--
    }, 1000)
  }

  // touch start
  const handleTouchStart = (e) => {
    if (loading) {
      return false
    }
    e.preventDefault()
    onStart?.()
    if (wxConfigG.isInited()) {
      wx.startRecord({
        success: function (res) {
          setIsRecording(true)
          const tempFilePath = res.tempFilePath
          startCountDown()
        },
        fail: function (err) {
          console.log(err, 'err')
        }
      })
    } else {
      Recorder.get((rec) => {
        recorder.current = rec
        setIsRecording(true)
        rec.start().then(res => {
          startCountDown()
        })
      })
    }
    timer.current = setTimeout(function () {
      e.preventDefault()
      return false
    }, 800)
  }

  // touch move
  const handleTouchMove = () => {
    clearTimeout(timer.current)
    timer.current = 0
  }

  // touch end
  const handleTouchEnd = () => {
    clearTimeout(timer.current)
    timer.current = null
    clearInterval(voiceDurationInter.current)
    voiceDurationInter.current = null

    // 如果是主动停的，则松开按钮时要调用停止方法
    if (voiceDuration.current !== 0) {
      stopRecord()
    }
    setIsRecording(false)

    if (wxConfigG.isInited()) {
      if (voiceDuration.current === 0) {
        if (localId) {
          handleWxTranslate(localId)
        } else {
          setIsErr(true)
        }
      }
    } else {
      if (recorder.current) {
        const blob = recorder.current.getBuffer()
        let formData = new FormData()
        formData.append('f', blob)
        // let audio = document.getElementById('audio') as any
        // recorder.current.play(audio)
        setLoading(true)
        voiceServiceMobx.voiceMatch(formData).then(res => {
          const { content, info } = res
          handleVoiceCall(info.full_content, content)
        }).catch(err => {
          setLoading(false)
          setIsErr(true)
          console.log(err, 'err')
        })
      }
    }
    // timer.current = 0
    return false
  }

  // 结束录音
  const stopRecord = () => {
    if (wxConfigG.isInited()) {
      isRecording && wx.stopRecord({
        success: (res) => {
          const localId = res.localId
          setLocalId(localId)
          // 如果是主动停的，则直接进行微信识别
          if (voiceDuration.current !== 0) {
            handleWxTranslate(localId)
          }
        }
      })
    } else {
      recorder.current?.stop()
    }
  }

  // wx翻译
  const handleWxTranslate = (localId) => {
    setLoading(true)
    wx.translateVoice({
      localId, // 需要识别的音频的本地Id，由录音相关接口获得
      isShowProgressTips: 0, // 默认为1，显示进度提示
      success: function (res) {
        console.log(res.translateResult) // 语音识别的结果
        voiceServiceMobx.contentMatch(res.translateResult).then(res => {
          const { content, info } = res
          handleVoiceCall(info.full_content, content)
        }).catch(err => {
          console.log(err, 'err')
          setLoading(false)
          setIsErr(true)
        })
      }
    })
  }

  // 翻译
  const handleTranslate = (data: any) => {
    voiceServiceMobx.contentMatch(data).then(res => {
      const { content, info } = res
      handleVoiceCall(info.full_content, content)
    }).catch(err => {
      console.log(err, 'err')
      setLoading(false)
      setIsErr(true)
    })
  }

  // 处理语音结果
  const handleVoiceCall = async (content?: string, list?: IContentItem[]) => {
    if (!content || !content.length) {
      setLoading(false)
      setIsErr(true)
      return
    }
    setIsErr(false)
    setLocalId('')
    setLoading(false)
    setIsCallService(false)
    if (type === 'serviceRing' && isOpendServiceRing) {
      sendServiceRing(content).then(res => {
        setLoading(false)
        setIsCallService(true)
        countDownClose()
      }).catch((err) => {
        console.log(err, 'err')
        setLoading(false)
        setIsErr(true)
        setIsCallService(false)
      })
    } else {
      menuMobx.setSearchKey(content)
      setIsCallService(false)
      setLoading(false)
      onReject()

      if (list.filter(item => item.content_type === 'call_activity').length) {
        if (isOpenSearchActivity) {
          const act = await mpc.refreshActivity()
          const availableActsMap = await voiceServiceMobx.getActsList(act)
          voiceServiceMobx.setSearchList(availableActsMap)
          onResult?.()
          return
        }
      } else {
        if (isOpenSearchProduct) {
          const products = list.filter(item => item.content_type === 'product')
          const searchedProducts = voiceServiceMobx.getSearchedProducts(products)
          voiceServiceMobx.setSearchList(searchedProducts)
          onResult?.()
          return
        }
      }

      voiceServiceMobx.setSearchList([])
    }
  }

  const getConfigOpenArr = useMemo(() => {
    const { isOpenSearchProduct, isOpenSearchActivity, isOpendServiceRing } = voiceServiceMobx
    return [
      type === 'search' && !!isOpenSearchProduct && 'canSearchProduct',
      type === 'search' && !!isOpenSearchActivity && 'canSearchActivity',
      type === 'serviceRing' && !!isOpendServiceRing && 'canCallWaiter'
    ].filter(Boolean)
  }, [
    type,
    voiceServiceMobx.isOpenSearchProduct,
    voiceServiceMobx.isOpenSearchActivity,
    voiceServiceMobx.isOpendServiceRing,
  ])

  return (
    <div className={classNames('voice-service-content', className)}>
      <div className='sign'>
        {
          isRecording && (
            <>
              <p>{i18n.t('voice.listening')}</p>
              <img src={SOUNDGIF} alt='' />
            </>
          )
        }
        {
          !isRecording && (
            loading ? (
              // loading
              <div className='result'>
                <i className='iconfont icon-voice_loading'></i>
              </div>
            ) : (
              isErr ? (
                // 没听清
                <div className='result'>
                  <i className='iconfont icon-vioce_ear'></i>
                  <p>{i18n.t('voice.parsingfail')}</p>
                  <p>{i18n.t('voice.sayagain')}</p>
                </div>
              ) : (
                // 服务员已收到
                isCallService && (
                  <div className='result'>
                    <i className='iconfont icon-voice_complete'></i>
                    <p>{i18n.t('voice.hasCallService')}</p>
                    <p>{i18n.t('voice.waitamonment')}</p>
                  </div>
                )
              )
            )
          )
        }
      </div>
      <div className='content'>
        {
          (isRecording || isErr || loading || isCallService) ? (
            <></>
          ) : !!getConfigOpenArr.length && (
            <div className='tips'>
              {
                type === 'serviceRing' ? (
                  <p>- {i18n.t('common.or')} -</p>
                ) : (
                  <>
                    <div className='tip1'>
                      <p>{i18n.t('voice.serviceHelpCanSay1')}</p>
                      <p>{getConfigOpenArr.includes('canSearchProduct') ? i18n.t('voice.productName') : i18n.t('voice.discount')}</p>
                    </div>
                    {
                      (getConfigOpenArr.length > 1) && (
                        <div className='tip2'>
                          <p>- {i18n.t('common.or')} -</p>
                          {
                            getConfigOpenArr.length > 2 ? (
                              <p>{`${i18n.t('voice.productName1')}、${i18n.t('voice.discount')}`}</p>
                            ) : (
                              <p>
                                {
                                  getConfigOpenArr.includes('canCallWaiter') ? (getConfigOpenArr.includes('canSearchProduct') ? i18n.t('voice.productName1') : i18n.t('voice.discount')) : i18n.t('voice.discount')
                                }
                              </p>
                            )
                          }
                        </div>
                      )
                    }
                  </>
                )
              }
            </div>
          )
        }
        {
          !isCallService ? (
            <div className={`btn ${loading ? 'parsing' : ''} ${isRecording ? 'recording' : ''}`} onMouseDown={handleTouchStart} onMouseUp={handleTouchEnd} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
              <i className={`iconfont ${isRecording ? 'icon-voice_speak' : 'icon-vioce_microphone'}`}></i>
              <p>{i18n.t(`voice.${isRecording ? 'talking' : (type === 'serviceRing' ? 'talkSendDetail' : 'pressAndHoldToTalk')}`)}</p>
            </div>
          ) : (
            <div className='count-down'>{i18n.t('voice.closeTime', { num: closeDuration })}</div>
          )
        }
      </div>
    </div>
  )
}

export default observer(VoiceServiceContent)
